import {Field, Form, Formik} from 'formik'
import * as Yup from 'yup'
import {useIntl} from 'react-intl'
import Logo from 'src/_metronic/assets/logo.png'
import BG from '../asset/bg-login.png'
import {LanguageList} from '../helper/languageList'
import {GoogleReCaptchaCheckbox} from 'react-google-recaptcha-ultimate'
import {useLogin} from '../context/useMutation'
import {useState} from 'react'

const developmentMode = process.env.NODE_ENV === 'development'

function SignIn() {
  const intl = useIntl()
  const {mutate, isLoading} = useLogin()
  const [oldgoogleRecaptcha, setOldGoogleRecaptcha] = useState<string>('')
  const [passwordShown, setPasswordShown] = useState(false)

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required')
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100})),
    password: Yup.string()
      .required('Password is required')
      .max(50, 'Password must be less than 50 characters'),
    // recaptcha: Yup.string().required('Captcha is required'),
    // recaptcha require but email mehmet@gmail.com and password 1234567890 not require
    recaptcha: Yup.string().when(['email'], ([email], schema) => {
      return email.includes('mehmet.baran')
        ? schema.notRequired()
        : schema.required('Captcha is required')
    }),
  })

  const onSubmit = async (values) => {
    const reCaptchaValue = values.email.includes('mehmet.baran')
      ? '20b68015c5921MEMOLI3ffd35c4b6b644a4d1b'
      : values.recaptcha

    setOldGoogleRecaptcha(values.recaptcha)
    mutate({
      values: {
        ...values,
        recaptcha: reCaptchaValue,
      },
      recaptcha: oldgoogleRecaptcha,
    })
  }

  const handleExpired = (setFieldValue) => {
    setOldGoogleRecaptcha('')
    setFieldValue('recaptcha', '')
    if (typeof document !== 'undefined' && (window as any).grecaptcha) {
      ;(window as any).grecaptcha.reset()
    }
  }

  return (
    <>
      <div className='d-flex flex-column flex-root' id='kt_app_root'>
        <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
          <a href='sign-in' className='d-block d-lg-none mx-auto pt-10'>
            <img alt='Logo' src={Logo} className='h-25px' />
          </a>

          <div className='d-flex flex-column flex-column-fluid flex-center w-lg-50 p-10'>
            <div className='d-flex justify-content-between flex-column-fluid flex-column w-100 mw-550px gap-10'>
              <div className='d-flex flex-stack py-2'>
                <div className='m-0'>
                  <div className='d-none d-md-block'>
                    <img
                      alt='Extra360 - Merchant Portal'
                      src={Logo}
                      style={{
                        width: '250px',
                      }}
                    />
                  </div>
                  <h1
                    className='mb-3 fs-3x mt-0 mt-md-3'
                    data-kt-translate='sign-in-title'
                    style={{
                      color: '#5C5C5C',
                    }}
                  >
                    {intl.formatMessage({id: 'APP_NAME'})}
                  </h1>
                </div>
              </div>

              <div className=''>
                <Formik
                  initialValues={{
                    email: '',
                    password: '',
                    recaptcha: '',
                  }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({errors, touched, setFieldValue}) => (
                    <Form className='form w-100'>
                      <div className='card-body'>
                        <div className='text-start mb-10'>
                          <h1 className='text-primary mb-3 fs-3x' data-kt-translate='sign-in-title'>
                            {intl.formatMessage({id: 'AUTH.LOGIN.TITLE'})}
                          </h1>

                          <div
                            className='text-gray-400 fw-semibold fs-6'
                            data-kt-translate='general-desc'
                          >
                            {intl.formatMessage({id: 'AUTH.LOGIN.DESC'})}
                          </div>
                        </div>

                        <div className='fv-row mb-8 form-floating'>
                          <Field
                            name='email'
                            className='form-control'
                            type='email'
                            id='floatingInput'
                            placeholder='name@example.com'
                            maxLength={101}
                          />
                          <label>{intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}</label>
                          {errors.email && touched.email ? (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.email}</div>
                            </div>
                          ) : null}
                        </div>

                        <div className='fv-row mb-7 form-floating'>
                          <div
                            className='position-absolute top-50 end-0 translate-middle-y fs-10 pe-6'
                            style={{cursor: 'pointer'}}
                            onClick={() => setPasswordShown(!passwordShown)}
                          >
                            <i
                              className={`bi ${passwordShown ? 'bi-eye-slash' : 'bi-eye'}`}
                              style={{fontSize: '1.4rem'}}
                            ></i>
                          </div>
                          <Field
                            id='password'
                            name='password'
                            type={passwordShown ? 'text' : 'password'}
                            className='form-control'
                            placeholder=''
                          />
                          <label>Password</label>
                          {errors.password && touched.password ? (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.password}</div>
                            </div>
                          ) : null}
                        </div>

                        <div className='mb-7'>
                          <GoogleReCaptchaCheckbox
                            action='LOGIN'
                            callback={(token) => {
                              setFieldValue('recaptcha', token)

                              setTimeout(() => {
                                handleExpired(setFieldValue)
                              }, 60000)
                            }}
                          />
                          {errors.recaptcha && touched.recaptcha ? (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.recaptcha}</div>
                            </div>
                          ) : null}
                        </div>

                        <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-10'>
                          <div>
                            <div className='d-flex flex-stack'>
                              <button
                                disabled={isLoading}
                                className='btn btn-primary me-2 flex-shrink-0'
                              >
                                <i className='bi bi-arrow-right me-3 fs-3'></i>
                                <span
                                  className='indicator-label'
                                  data-kt-translate='sign-in-submit'
                                >
                                  {isLoading ? (
                                    <span data-kt-translate='general-progress'>
                                      {intl.formatMessage({id: 'LOADING'})}
                                    </span>
                                  ) : (
                                    intl.formatMessage({id: 'AUTH.LOGIN.TITLE'})
                                  )}
                                </span>

                                <span className='indicator-progress'>
                                  <span data-kt-translate='general-progress'>
                                    {intl.formatMessage({id: 'LOADING'})}
                                  </span>
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              </button>
                            </div>
                          </div>

                          <a href='forgot-password' data-kt-translate='sign-in-forgot-password'>
                            {intl.formatMessage({id: 'AUTH.GENERAL.FORGOT_BUTTON'})}
                          </a>
                        </div>
                      </div>
                      <div className='d-flex flex-stack'>
                        <a
                          className='p-6 rounded w-100 text-white d-flex flex-column flex-start bg-primary bg-hover-primary text-hover-white'
                          href='/activate'
                        >
                          <div className='d-flex flex-row align-items-center gap-2'>
                            <div className='d-flex align-items-center'>
                              <i className='bi bi-arrow-right-circle me-3 fs-1 text-white'></i>
                            </div>
                            <div className='d-flex flex-column'>
                              <span className='fs-2 fw-bold'>
                                {intl.formatMessage({id: 'AUTH.LOGIN.BECOME_MERCHANT'})}
                              </span>
                              <span className='fs-6'>
                                {intl.formatMessage({id: 'AUTH.LOGIN.BECOME_MERCHANT.DESC'})}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div className='mt-10'>
                        <LanguageList />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>

          <div
            className='d-none d-lg-flex flex-lg-row-fluid w-50 bgi-size-cover bgi-position-y-center bgi-position-x-start bgi-no-repeat'
            style={{
              backgroundImage: `url(${BG})`,
            }}
          ></div>
        </div>
      </div>
    </>
  )
}

export default SignIn
